import {defineMessages} from 'react-intl';

export default defineMessages({
	quantity: {
		id: 'orders.quantity',
		defaultMessage: 'Qty'
	},
	title: {
		id: 'orders.details.summary.title',
		defaultMessage: 'Order Summary'
	},
	itemSubtotal: {
		id: 'orders.details.summary.itemSubtotal',
		defaultMessage: 'Item Subtotal'
	},
	delivery: {
		id: 'orders.details.summary.delivery',
		defaultMessage: 'Delivery '
	},
	orderTotal: {
		id: 'orders.details.summary.orderTotal',
		defaultMessage: 'Total'
	},
});
